const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/middleware/index.ts';
import { cache, callApi, timeout } from '@cistec/common_web/middleware/index';
import { getMainConfig } from '@cistec/common_web/services/mainConfig';
import oauth2 from 'App/middleware/oauth2';
import patApiMiddleware from 'App/middleware/patapi';

const patapiConfig = {
    baseUrl: getMainConfig().settings.apiHost,
    pipeline: [cache, oauth2(), timeout(getMainConfig().settings.apiResponseTimeout), callApi],
};

export const patapi = patApiMiddleware(patapiConfig);
